var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(-212 -248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "appointment-new-svgrepo-com",
    d: "M29.65,18.483a1,1,0,0,0-1,1V24.49h-3a1,1,0,1,0,0,2h4a1,1,0,0,0,1-1V19.484A1,1,0,0,0,29.65,18.483Z",
    transform: "translate(195.365 235.524)",
    fill: "#081831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M13,26A13,13,0,0,1,7.94,1.022,13,13,0,0,1,18.06,24.978,12.92,12.92,0,0,1,13,26ZM13,3.9A9.1,9.1,0,1,0,22.1,13,9.11,9.11,0,0,0,13,3.9Z",
    transform: "translate(212 248)",
    fill: "#081831"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeMobileIcon);
export default __webpack_public_path__ + "static/media/timeMobileIcon.f846f73ed62168f39ca5d2b7642987ba.svg";
export { ForwardRef as ReactComponent };